import React from "react";
import { ArrowRightIcon, CaravanIcon, ClipboardListIcon, ContainerIcon, HammerIcon, SprayCanIcon, TruckIcon, BoxIcon } from "lucide-react";
import { linkTargetProps } from "../utils/links";
import { Service, ServiceIconKey } from "../types/site";
const iconMap: Record<ServiceIconKey, BoxIcon> = {
  collision: HammerIcon,
  semi: TruckIcon,
  boxTruck: ContainerIcon,
  paint: SprayCanIcon,
  fleet: ClipboardListIcon,
  trailer: CaravanIcon
};
interface ServiceCardProps {
  service: Service;
}
export function ServiceCard({
  service
}: ServiceCardProps) {
  const Icon = iconMap[service.icon];
  return <a href={service.href} {...linkTargetProps(service.href)} className="group relative flex h-full w-full min-w-0 flex-col bg-paper p-5 transition-colors duration-200 ease-out hover:bg-paper-bright md:p-9" data-id="element-242" data-mp="39ag8pkfrbm05">
      <div className="flex items-start justify-between" data-id="element-243" data-mp="3j9ynlmgt8hlc">
        <Icon aria-hidden="true" className="h-8 w-8 text-ink transition-colors duration-200 ease-out group-hover:text-brand" strokeWidth={1.5} data-id="element-244" data-mp="3o807uapz2mye" />
        <span className="font-display text-[15px] font-semibold tracking-[0.12em] text-steel" data-id="element-245" data-mp="24atulovbqxqi">{service.number}</span>
      </div>
      <h3 className="mt-6 font-display md:mt-10 text-[28px] font-bold uppercase leading-[0.95] tracking-[0.01em] text-ink md:text-[30px]" data-id="element-246" data-mp="1z9e95vp8ip7l">
        {service.title}
      </h3>
      <p className="mt-3 text-[16px] leading-relaxed text-steel" data-id="element-247" data-mp="1qbc9bjh8m2lw">{service.description}</p>
      <span className="mt-auto flex items-center justify-between pt-6 text-[13px] md:pt-9 font-semibold uppercase tracking-[0.12em] text-ink" data-id="element-248" data-mp="2mz8ja5i65zo5">
        {service.linkLabel}
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1 group-hover:text-brand" data-id="element-249" data-mp="2da8icgk3wu7b" />
      </span>
      <span aria-hidden="true" className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 bg-brand transition-transform duration-200 ease-out group-hover:scale-x-100" data-id="element-250" data-mp="296sm3lby8vv5" />
    </a>;
}